import { useState } from 'react';
import './Misproyectos.css';
import imagen3 from '../businessadminweb-image.PNG'
import imagen2 from '../timberli-project.png'
import imagen1 from '../food-image.PNG'
import imagen4 from '../movieapp-image.png'
import imagen5 from '../order-app-image.png'
import imagen6 from '../movienightweb-image.PNG'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {NextArrow, PrevArrow} from './CustomArrowsSlider';
export default function Misproyectos(){
  const [onHover,setOnHover]= useState({on:false, in:null})
    const objProyect=[
      {name:'Movies&SeriesWebApp',link:"https://entertainment-web-app-ten-psi.vercel.app/", imagen:imagen6, resumen: "Movies and series app:app developed with react/next and firebase.", github:'https://github.com/LucianoMocchegiani/entertainment-web-app'},
      {name:'BusinesAdmin',link:'https://business-admin.vercel.app/',imagen:imagen3,resumen:"Busines Admin:   Web and mobile app to manage commercial businesses, the main technologies applied are React, React Native with Expo and Firebase. ", github:'https://github.com/LucianoMocchegiani/business-admin-web-app'},
       {name:'Movies&SeriesApp',link:"https://expo.dev/artifacts/eas/c63mXaD4p77QbUfT8xdRPs.apk", imagen:imagen4, resumen: "Movies and series app:app developed with react native, expo, firebase.", mobile:true, github:'https://github.com/LucianoMocchegiani/enterteinment-mobile-app'},
       {name:'OrderStoreApp',link:"https://expo.dev/artifacts/eas/jGKgozWyeyWPLzwadd8gYM.apk", imagen:imagen5, resumen: "App to make and manage purchase orders.",  mobile:true, github:'https://github.com/LucianoMocchegiani/ordering-mobile-app'},
      {name:'Timberli',link:"https://proyecto-final-orcin-seven.vercel.app/", imagen:imagen2, resumen: "Timberli:   It is a social network where software developers upload and expose their portfolio of projects. The technologies used: React Redux on the frontend and Node.js, Express.js and Sequelize on the backend. Account with authentication (Oauth2.0), Payment method implemented with STRIPE. ",github:'https://github.com/LucianoMocchegiani/academic-final-project'},
      {name:'Food Recipes',link:"https://pi-food-kappa.vercel.app/",imagen:imagen1,resumen:"Food Recipes:   It is a web application where food recipes are created and displayed. The technologies used: React Redux on the frontend and Node.js, Express.js and Sequelize on the backend.",github:'https://github.com/LucianoMocchegiani/pi-food-academic-project-web-app'}]

      var settings = {
        
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 0,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      };

    return(<>
        <div className='cabezaProyectos'>
          <h1 className='title-mis-proyectos'>My projects </h1>
          <p className='subTitle textProyectos' id='misProyectos'>These are the projects he worked on. I am always willing to learn new technologies and work with new people.</p>
        </div>
        <div className="misproyectos-container"> 
        <Slider {...settings}>
        {objProyect.map((item)=>(
          <div className='card' key={item.name+'1'} onMouseEnter={()=>setOnHover({on:true, in:item.name+'1'})} onMouseLeave={()=>setOnHover({on:false, in:null})}>
            {onHover.on&&<a href={item.link} target="_blank"><p key={item.name+'1'} className={onHover.in===item.name+'1'?'visitar':'displayNone'}>{item.mobile?'Dowload Apk for android':'Visit web site'}</p></a>}
              {onHover.on&&<a href={item.github} target="_blank"><p key={item.name+'1'} className={onHover.in===item.name+'1'?'visitartwo':'displayNone'}>{'Visit code on github'}</p></a>}
            <div className='card-top'>
              <img src={item.imagen} alt={item.name} width={'500px'} height={'250'}/>
              
            </div>
            <div className='card-bottom'>
              <p className='resumenText'>{item.resumen}</p>
            </div>
          </div>
        ))}
        </Slider>
        </div>
        </>
    )
}
// {proyectoHover&&
